import { AuthService } from "./../../shared/models/auth.service";
import { WeGoConfig, IAPIResponse } from "./../../shared/config";
import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";

@Injectable()
export class BackofficeService {
  constructor(private authService: AuthService, private http: Http) {}

  public GetUserSettingByPersonHashID(): Observable<IAPIResponse> {
    let getRolesUrl = WeGoConfig.API_GET_USER_SETTING_BY_PERSON;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getRolesUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/backoffice/models/backoffice.service.ts